// extracted by mini-css-extract-plugin
export default {"select__container":"SortSelect_select__container__-ocFu"};